'use client';

import Link from 'next/link';
import { AndercoreExternalLinks } from '~/constants/endpoints';
import { useI18n } from '~/locales/client';
import { LocaleEnum } from '~/locales/resources';

type TermsAndConditionsClientProps = {
  locale: LocaleEnum;
};

/**
 * Client-side TermsAndConditions component
 * @param locale - The locale to use
 * @returns TermsAndConditions component
 */
const TermsAndConditionsClient = ({ locale }: TermsAndConditionsClientProps) => {
  const translate = useI18n();

  return (
    <div className="px-1 justify-self-center text-center">
      <Link
        href={AndercoreExternalLinks?.[locale]?.privacy ?? ''}
        className="text-sm leading-4 text-gray-900 hover:underline"
        rel="noopener noreferrer"
      >
        {translate('page.login.view.privacy' as never)}
      </Link>{' '}
      -{' '}
      <Link
        href={AndercoreExternalLinks?.[locale]?.imprint ?? ''}
        className="text-sm leading-4 text-gray-900 hover:underline"
        rel="noopener noreferrer"
      >
        {translate('page.login.view.imprint' as never)}
      </Link>
    </div>
  );
};

export default TermsAndConditionsClient;
